import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Layout principal del módulo Inventario.
 *
 * En III.1 inicial, este layout renderizaba un sidebar secundario
 * propio a la izquierda + Outlet a la derecha. Esto fue un error: la
 * intranet ya tiene su propia franja gris (`<ul className="lista
 * lista-secundaria">` en Sidebar.js) que es donde DEBE vivir el
 * submenú del módulo.
 *
 * Por eso ahora este layout no renderiza nada propio: solo el Outlet
 * con las páginas hijas. El InventarioSidebar se monta directamente
 * en Sidebar.js mediante una rama nueva del if-ladder por `numbtn`,
 * para reutilizar la misma franja gris que usan las demás secciones
 * (Personas, Wiki, Vacaciones, etc.).
 *
 * El padding y fondo del área de contenido los gestiona cada página
 * individualmente (px-6 py-5 sobre bg-slate-50), siguiendo el patrón
 * de las pantallas migradas al DS v2.
 */

export default function InventarioLayout() {
  return <Outlet />;
}
